import { format, formatDistanceToNowStrict } from 'date-fns';
import { ChallengeStatus } from '@api/ChallengeClient';

const STALE_AFTER_MS = 24 * 60 * 60 * 1000;

export const formatJoined = (iso: string) => format(new Date(iso), 'd MMM');

export const describeLastSync = (iso: string | undefined, inProgress: boolean) => {
    if (!iso) {
        return { label: 'Never synced', warning: inProgress };
    }
    const stale = Date.now() - new Date(iso).getTime() > STALE_AFTER_MS;
    return {
        label: `${formatDistanceToNowStrict(new Date(iso))} ago`,
        warning: inProgress && stale
    };
};

export const challengeStatusVariant = (status: ChallengeStatus) =>
    status === ChallengeStatus.IN_PROGRESS ? 'info' : 'muted';
